'use client';
import { PrivyProvider } from '@privy-io/react-auth';
import React from 'react';

interface PrivyWrapperProps {
	children: React.ReactNode;
}

const PrivyWrapper = ({ children }: PrivyWrapperProps) => {
	return (
		<PrivyProvider
			appId={process.env.NEXT_PUBLIC_PRIVY_APP_ID!}
			config={{
				loginMethods: [
					'email',
					'sms',
					'google',
					'discord',
					'telegram',
					'wallet',
				],

				appearance: {
					theme: 'dark',
					accentColor: '#676FFF',
					logo: 'https://cdn.otherworld.xyz/public/assets/logo/main-logo-white.png',
					walletList: ['metamask', 'wallet_connect'],
				},
			}}
		>
			{children}
		</PrivyProvider>
	);
};

export default PrivyWrapper;
